const situations = [
  'компания быстро растёт, и появляются новые пересечения ответственности;',
  'появляются новые руководители, которым не хватает навыков работы с конфликтами;',
  'подразделения работают разрозненно и «перекидывают» проблемы друг на друга;',
  'увеличивается количество внутренних конфликтов и жалоб;',
  'собственник постоянно вмешивается в споры и становится «верховным судьёй»;',
  'руководители избегают сложных разговоров и откладывают решение проблем;',
  'сотрудники жалуются друг на друга вместо прямого диалога;',
  'есть проблемы с ответственностью: непонятно, кто за что отвечает;',
  'компания внедряет изменения и сталкивается с сопротивлением команды;',
  'происходят реорганизация или масштабирование;',
  'требуется развитие управленческой культуры и единых правил взаимодействия.',
];

export default function SuitableCompanies() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Когда обучение особенно актуально
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Управление конфликтами даёт наибольший эффект, когда компания растёт, меняется или сталкивается с ростом внутренних споров
        </p>

        <div className="grid sm:grid-cols-2 gap-3 max-w-4xl mx-auto">
          {situations.map((s, i) => (
            <div key={i} className="flex items-start gap-2.5 bg-white rounded-lg border border-gray-200 p-4 hover:border-teal-300 transition-colors">
              <i className="ri-checkbox-circle-line text-teal-600 mt-0.5 flex-shrink-0"></i>
              <span className="text-sm text-gray-700 leading-relaxed">{s}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}